<template>
  <div v-if="hasBandList">
    <template v-for="(sectionInfo, index) in multiSectionList">
      <DynamicSectionLoader :section-info="sectionInfo" :key="sectionInfo.title + $route.name + index" />
    </template>
  </div>
</template>
<script>

import { getLiveRecommendMultiSection } from '@/common/utils/request'
import DynamicSectionLoader from '@/components/container/DynamicSectionLoader'
import _ from 'lodash'
import { onDisplay } from '@/common/resources/directives'

export default {
  name: 'LiveMultiSection',
  components: {
    DynamicSectionLoader
  },
  props: {
    channelInfo: {
      type: Object
    },
    channelId: {
      type: String
    }
  },
  directives: {
    onDisplay
  },
  data () {
    return {
      multiSectionList: []
    }
  },
  computed: {
    hasBandList () {
      return this.multiSectionList.length
    }
  },
  methods: {
    setData () {
      getLiveRecommendMultiSection({
        channelid: this.channelId,
        timeStamp: new Date().getTime()
      }).then(({ data }) => {
        this.multiSectionList = _.get(data, 'multisectionlist', [])
      })
    },
    attachReloadEvent () {
      this.$events.$on('reload', () => {
        this.multiSectionList = []
        this.setData()
      })
    },
    detachReloadEvent () {
      this.$events.$off('reload')
    }
  },
  created () {
    this.setData()
  },
  mounted () {
    this.attachReloadEvent()
  },
  beforeDestroy () {
    this.detachReloadEvent()
  },
  watch: {
    channelId () {
      this.setData()
    }
  }
}
</script>
